var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8843 29.4224C48.8843 27.9683 48.7538 26.5702 48.5115 25.228H29.1989V33.16H40.2346C39.7593 35.7232 38.3146 37.8949 36.1428 39.349V44.4941H42.7699C46.6473 40.9242 48.8843 35.6673 48.8843 29.4224Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1988 49.4621C34.7353 49.4621 39.377 47.626 42.7698 44.4942L36.1427 39.3491C34.3066 40.5795 31.9577 41.3065 29.1988 41.3065C23.858 41.3065 19.3374 37.6993 17.7249 32.8525H10.8741V38.1654C14.2483 44.867 21.1829 49.4621 29.1988 49.4621Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7251 32.8526C17.3149 31.6222 17.0819 30.308 17.0819 28.9565C17.0819 27.605 17.3149 26.2907 17.7251 25.0604V19.7476H10.8743C9.4855 22.5158 8.69324 25.6476 8.69324 28.9565C8.69324 32.2653 9.4855 35.3971 10.8743 38.1654L17.7251 32.8526Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1988 16.6064C32.2094 16.6064 34.9124 17.641 37.0375 19.6729L42.9189 13.7915C39.3677 10.4826 34.726 8.45068 29.1988 8.45068C21.1829 8.45068 14.2483 13.0458 10.8741 19.7475L17.7249 25.0603C19.3374 20.2135 23.858 16.6064 29.1988 16.6064Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.06ae5c6eccad6772df0626297bac8aac.svg";
export { ForwardRef as ReactComponent };